// extracted by mini-css-extract-plugin
export default {"STLLogo":"Logo_STLLogo__H3Bgx","EboardLogo":"Logo_EboardLogo__Vrxmb"};